import Vue from 'vue'
import Vuex from 'vuex'
import ui from "./modules/ui";

Vue.use(Vuex)

import usuario from './usuario/usuario'
import cargo from './cargo/cargo'
import unidadeAdm from './unidadeAdm/unidadeAdm'
import local from './local/local'
import departamento from './departamento/departamento'
import perfil from './perfil/perfil'
import permissao from './permissao/permissao'
import empresa from './empresa/empresa'
import fornecedor from './fornecedor/fornecedor'
import limite from './limite/limite'
import endereco from './endereco/endereco'
import grupoProduto from './grupoProduto/grupoProduto'
import marca from './marca/marca'
import unidadeMedida from './unidadeMedida/unidadeMedida'
import produto from './produto/produto'
import equipamento from './equipamento/equipamento'
import implemento from './implemento/implemento'
import familia from './familia/familia'
import marcaEquipamento from './marcaEquipamento/marcaEquipamento'
import modelo from './modelo/modelo'
import grupoEquipamento from './grupoEquipamento/grupoEquipamento'
import controleFrota from './controleFrota/controleFrota'
import sistema from './sistema/sistema'
import horimetroKM from './horimetroKM/horimetroKM'
import pedido from './pedido/pedido'
import solicitacao from './solicitacao/solicitacao'
import requisicao from './requisicao/requisicao'
import requisicaoServico from './requisicaoServico/requisicaoServico'
import centroCusto from './centroCusto/centroCusto'
import mapaCotacao from './mapaCotacao/mapaCotacao'
import condicaoPagamento from './condicaoPagamento/condicaoPagamento'
import mecanico from './mecanico/mecanico'
import planoManutencao from './planoManutencao/planoManutencao'
import servicoPlano from './servicoPlano/servicoPlano'
import localizacao from './localizacao/localizacao'
import ordemServico from './ordemServico/ordemServico'
import protocoloEntrega from './protocoloEntrega/protocoloEntrega'
import entradaNF from './entradaNF/entradaNF'
import pedidoAvulso from './pedidoAvulso/pedidoAvulso'
import chamadoManutencao from './chamadoManutencao/chamadoManutencao'
import periodicidade from './periodicidade/periodicidade'
import compartimento from './compartimento/compartimento'


const store = new Vuex.Store({
    modules: {
		usuario,
		cargo,
		unidadeAdm,
		empresa,
		local,
		departamento,
		permissao,
		perfil,
		fornecedor,
		limite,
		endereco,
		grupoProduto,
		marca,
		unidadeMedida,
		produto,
		equipamento,
		implemento,
		familia,
		marcaEquipamento,
		modelo,
		grupoEquipamento,
		sistema,
		controleFrota,
		horimetroKM,
		pedido,
		solicitacao,
		requisicao,
		requisicaoServico,
		centroCusto,
		mapaCotacao,
		condicaoPagamento,
		mecanico,
		planoManutencao,
		servicoPlano,
		localizacao,
		ordemServico,
		protocoloEntrega,
		entradaNF,
		pedidoAvulso,
		chamadoManutencao,
		periodicidade,
		compartimento,
		ui 
    }
});

export default store